import { resHandle2, axiosM } from "@/plugins/axios";
/**
 * @description 无权限获取实体列表和详情
 * @url https://app.apifox.com/link/project/3433166/apis/api-249829575
 * @api /api/knowledge/entity_guest
 */
const GetKnowledgeList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axiosM.get("api/knowledge/entity_guest", params).then(({ data }) => {
            resHandle2(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err: any) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 获取图谱
 * @param vCom Vue组件
 */
const GetTupu = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axiosM.get("api/knowledge/entity/tupu", params).then(({ data }) => {
            resHandle2(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err: any) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
export { GetKnowledgeList, GetTupu }